<div class="flex flex-col items-center justify-center">
    <div class="w-full flex items-center justify-end">
        <button (click)="onDismiss()" class="w-6 h-6 rounded-md bg-gray-100">
            <i class="fas fa-times text-sm text-gray-500"></i>
        </button>
    </div>
    <p class="font-semibold font-display text-gray-700">Filter Data</p>
    <form [formGroup]="form" (ngSubmit)="onConfirm()" class="mt-8 w-full font-display grid grid-cols-2 gap-4">
        <!-- <div class="flex flex-col space-y-2">
            <p class="text-sm font-display text-gray-600">Status :</p>
            <mat-select formControlName="status_id" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full text-sm text-gray-500 focus:outline-none" placeholder="Pilih status">
                <mat-option value="all" class="font-display">Semua</mat-option>
                <mat-option class="font-display capitalize" *ngFor="let status of status" [value]="status.id">{{status.label}}</mat-option>
            </mat-select>
        </div> -->
        <div class="flex flex-col space-y-2">
            <p class="text-sm font-display text-gray-600">Kategori :</p>
            <mat-select formControlName="category" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full text-sm text-gray-500 focus:outline-none" placeholder="Pilih kategori">
                <mat-option value="all" class="font-display">Semua</mat-option>
                <mat-option class="font-display capitalize" *ngFor="let cat of category" [value]="cat.id">{{cat.category}}</mat-option>
            </mat-select>
        </div>
        <div class="flex flex-col space-y-2">
            <p class="text-sm font-display text-gray-600">Kecamatan :</p>
            <mat-select formControlName="district_id" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full text-sm text-gray-500 focus:outline-none" placeholder="Pilih kecamatan">
                <mat-option value="all" class="font-display">Semua</mat-option>
                <mat-option class="font-display capitalize" *ngFor="let district of district" [value]="district.id">{{district.name}}</mat-option>
            </mat-select>
        </div>
        <div class="flex flex-col space-y-2">
            <p class="text-sm font-display text-gray-600">Level Prioritas :</p>
            <mat-select formControlName="priority" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full text-sm text-gray-500 focus:outline-none" placeholder="Pilih prioritas">
                <mat-option value="all" class="font-display">Semua</mat-option>
                <mat-option class="font-display capitalize" [value]="'high'">Utama</mat-option>
                <mat-option class="font-display capitalize" [value]="'medium'">Sedang</mat-option>
                <mat-option class="font-display capitalize" [value]="'low'">Biasa</mat-option>
            </mat-select>
        </div>
        <!-- <div class="flex flex-col space-y-2">
            <p class="text-sm font-display text-gray-600">Jenis Program :</p>
            <mat-select formControlName="is_musrenbang" class="font-display h-11 px-4 bg-gray-100 rounded-md py-3 w-full text-sm text-gray-500 focus:outline-none" placeholder="Pilih tipe proposal">
                <mat-option value="all" class="font-display">Semua</mat-option>
                <mat-option class="font-display capitalize" [value]="1">Musrenbang</mat-option>
                <mat-option class="font-display capitalize" [value]="0">Non-Musrenbang</mat-option>
            </mat-select>
        </div> -->
        <div class="flex w-full items-center justify-end mt-4 col-span-2">
            <button type="submit" class="px-3 py-2 text-white font-medium font-display text-sm bg-primary rounded-md">Simpan</button>
        </div>
    </form>
</div>